<template>
  <div class="home-page">
    <div class="header">
      <div class="logo">
        <img src="@/assets/img/weopinions.png" alt="logo" />
      </div>
      <div class="menu" @click="openSheet"><van-icon name="bars" /></div>
    </div>
    <div class="content">
      <div class="content-1">
        <div>{{ $t("text1") }}</div>
        <div>{{ $t("text2") }}</div>
      </div>
      <div class="content-2">
        <div>{{ $t("text3") }}</div>
        <div>{{ $t("text4") }}</div>
      </div>
      <div class="content-3">
        <van-button round type="info" @click="toLogin">{{
          $t("btnText")
        }}</van-button>
      </div>
    </div>
    <div class="footer">
      <div class="card">
        <div>
          <van-image width="1rem" height="1rem" :src="register" />
        </div>
        <div class="text">1.{{ $t("rigisterText") }}</div>
      </div>
      <div class="card">
        <div style="margin-top: 0.1rem">
          <van-image width=".8rem" height=".8rem" :src="survey" />
        </div>
        <div>2.{{ $t("joinText") }}</div>
      </div>
      <div class="card">
        <div>
          <van-image width="1rem" height="1rem" :src="award" />
        </div>
        <div>3.{{ $t("activeText") }}</div>
      </div>
      <van-popup
        class="popup"
        v-model="showSheet"
        position="right"
        :style="{ height: '100%', width: '50vw' }"
      >
        <van-cell
          icon="guide-o"
          :title="$t('sideBar.lang')"
          @click="handleJump(1)"
        />
        <van-cell
          icon="gold-coin-o"
          :title="$t('sideBar.jifen')"
          @click="handleJump(2)"
        />
        <van-cell
          icon="question-o"
          :title="$t('sideBar.about')"
          @click="handleJump(3)"
        />
        <van-cell
          icon="service-o"
          :title="$t('sideBar.help')"
          @click="handleJump(4)"
        />
      </van-popup>
      <van-action-sheet
        class="sheet"
        v-model="showLangSheet"
        :actions="actions"
        @select="onSelect"
      />
    </div>
    <div class="meng-ban"></div>
  </div>
</template>

<script>
import survey from "@/assets/img/参与调研.png";
import award from "@/assets/img/活动奖励.png";
import register from "@/assets/img/免费注册.png";
export default {
  name: "PicNewspaper",
  components: {},
  data() {
    return {
      showSheet: false,
      showLangSheet: false,
      actions: [
        /*{ id: "1", name: "中文" },*/
        { id: "2", name: "English" },
      ],
      award: award,
      register: register,
      survey: survey,
    };
  },
  methods: {
    toHome() {
      this.$router.push({
        path: '/',
      });
    },
    openSheet() {
      this.showSheet = !this.showSheet;
    },
    onSelect(value) {
      if (value.id == "1") {
        this.$i18n.locale = "zh";
      } else {
        this.$i18n.locale = "en";
      }
      localStorage.setItem("lang", this.$i18n.locale);
      this.showSheet = false;
      this.showLangSheet = false;
    },

    handleJump(flag) {
      switch (flag) {
        case 1:
          this.showLangSheet = true;
          break;
        case 2:
          this.$router.push("/integralAward");
          break;
        case 3:
          this.$router.push("/aboutQuestionnaire");
          break;
        case 4:
          this.$router.push("/helpFeedback");
          // this.$router.push("/offenQuestion");
          break;
        default:
          break;
      }
    },
    toLogin() {
      this.$router.push("/register");
    },
  },
};
</script>

<style lang="stylus" scoped>
.home-page {
  width: 100%;
  height: 100%;
  overflow: scroll;
  overflow-x: hidden;
  background: url('../../../assets/img/画报背景.png');
  background-size: 100% 100%;
  position: relative;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px;

    .logo {
      font-size: 1rem;

      img {
        position: relative;
        left: -30px;
        width: 300px;
        height: 75px;
      }
    }

    .menu {
      color: white;
      font-size: 0.6rem;
    }
  }

  .content {
    padding: 0 0 0 30px;
    margin-top: 5vh;

    .content-1 {
      line-height: 0.8rem;
      color: #FFFFFF;
      font-size: 0.75rem;
    }

    .content-2 {
      margin-top: 6vh;
      color: #FFFFFF;
      font-size: 0.375rem;
      line-height: 0.5rem;
    }

    .content-3 {
      margin-top: 30px;

      button {
        width: 50%;
        background: #5F6AED;
        border: #5F6AED;
        font-size: 0.3rem;
        font-weight: 500;
      }
    }
  }

  .footer {
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    color: white;
    justify-content: center;

    .card {
      width: 30vw;
      text-align: center;
      font-size: 0.3rem;
      font-weight: bold;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .van-image {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
<style scoped>
@media only screen and (min-width: 768PX) {
  .popup {
    position: fixed;
    width: 50%;
    max-width: 384PX;
    right: calc(50% - 384PX);
  }
  .footer /deep/ .van-overlay {
    width: 100%;
    max-width: 768PX;
    left: 50%;
    transform: translateX(-50%);
  }
  .footer /deep/ .sheet {
    width: 100%;
    max-width: 768PX;
    margin-left: calc(50% - 384PX);
    /* left: 50%; */
    /* transform: translateX(-50%); */
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/components/PicNewspaper.vue